<template>
  <div class="htmltext">
    <img :src="imageurl" :width="imagewidth" />
    <div v-if="isemail == 1">
      <a :href="'mailto:' + message"
        ><span>{{ message }}</span></a
      >
    </div>
    <div v-else>
      <span
        >{{ message
        }}<span v-if="isemail == 3" class="messagecode"
          >按2咨询设纪元</span
        ></span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["message", "imageurl", "imagewidth", "isemail"]
};
</script>

<style scoped>
.htmltext {
  color: #fff;
  font-size: 20px;
  /* margin-top: 31px;
        margin-bottom: 12px; */
  display: flex;
  align-items: center;
}
.htmltext div {
  display: inline-block;

  line-height: 40px;
  margin-left: 10px;
}
.htmltext div span {
  font-weight: 700;
  font-size: 22px;
  color: #fff;
}
.htmltext .messagecode {
  font-weight: 500;
  font-size: 16px;
  margin-left: 8px;
}
.htmltext img {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HtmlTextAndImg.vue